<dynamic-material-form
  #requiredForm
  class="dokument-angabe-form"
  [model]="requiredFormModel"
  [group]="requiredFormGroup"
  (change)="onFormChange()"
  (keydown)="onFormChange()"
  (matEvent)="onCustomEvent($event)"
  data-test="gsm-dokument-angabe_required"
></dynamic-material-form>
<dynamic-material-form
  #optionalForm
  class="dokument-angabe-form"
  [model]="optionalFormModel"
  [group]="optionalFormGroup"
  (change)="onFormChange()"
  (keydown)="onFormChange()"
  (matEvent)="onCustomEvent($event)"
  data-test="gsm-dokument-angabe_optional"
></dynamic-material-form>
<div *ngIf="!model.disabled" class="buttons-container">
  <div class="add-button-container inline-flex" (click)="addDocument()">
    <button mat-mini-fab class="add-button" color="primary" data-test="gsm-dokumenten-angabe_add-btn">
      <mat-icon>add</mat-icon>
    </button>
    <span>Dokument hinzufügen</span>
  </div>
  <div class="add-button-container inline-flex" (click)="onMultipleDocumentsClick()">
    <button mat-mini-fab class="add-button" color="primary" data-test="gsm-dokumenten-angabe_add-multiple-btn">
      <mat-icon>add</mat-icon>
    </button>
    <span>Outlook-Upload/Mehrere Dokumente hinzufügen</span>
  </div>
</div>
